import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';

const PrivacyMain = () => {
  return (
    <main>
      <HeaderFive />
      <Breadcrumb title="Privacy Policies" />

      <div style={styles.wrapper}>
        <div style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.title}>Privacy Policy</h1>
            <p style={styles.subtitle}>
              <strong>Rawalpindi Institute of Cardiology (RIC)</strong><br />
              Effective Date: 15th May, 2025<br />
              Last Updated: 28th June, 2025
            </p>
          </div>

          <section style={styles.section}>
            <p>
              At Rawalpindi Institute of Cardiology (RIC), we are committed to protecting your privacy and providing a safe, secure experience across our digital platforms. This Privacy Policy outlines how we collect, use, and protect your data in compliance with applicable regulations and Google Play policies for health-related applications.
            </p>
          </section>

          <Section title="1. Scope of This Policy" items={[
            "Our official website: https://ricgop.online",
            "Our mobile application listed on Google Play, used exclusively by RIC-authorized medical staff for clinical operations including discharge summary verifications and internal dashboard access"
          ]} />

          <section style={styles.section}>
            <h2 style={styles.heading}>2. Data Collection and Use</h2>

            <h3 style={styles.subheading}>a) Personal Information (Website Forms)</h3>
            <List items={[
              "Name",
              "Email address",
              "Phone number",
              "Any other submitted form content"
            ]} />
            <p><strong>Purpose:</strong> To respond to inquiries, manage communication, and improve service quality.</p>

            <h3 style={styles.subheading}>b) App-Specific Information (Internal Use Only)</h3>
            <List items={[
              "Login credentials (e.g., email/ID, password)",
              "Internal staff ID or Doctor ID",
              "Discharge summary access logs",
              "Device information (for authentication and security)"
            ]} />
            <p><strong>Purpose:</strong> To enable secure, restricted access for RIC personnel only.</p>

            <h3 style={styles.subheading}>c) Automatically Collected Data</h3>
            <List items={[
              "IP address",
              "Browser/device type",
              "Operating system",
              "Usage patterns and session activity",
              "Cookies (see Section 6)"
            ]} />
            <p><strong>Purpose:</strong> Analytics, performance optimization, and security monitoring.</p>
          </section>

          <Section title="3. Use of Information" items={[
            "Respond to user-initiated inquiries",
            "Provide secure, role-based access to internal features",
            "Log and verify medical documentation actions",
            "Improve user experience and maintain system performance",
            "Ensure app and data security for hospital operations"
          ]} />

          <section style={styles.section}>
            <h2 style={styles.heading}>4. App Disclosure for Google Play</h2>
            <p>The RIC mobile application is intended solely for:</p>
            <List items={[
              "Use by authorized doctors at RIC",
              "Internal clinical operations, including discharge verification and reporting dashboards"
            ]} />
            <p><strong>Not intended for:</strong></p>
            <List items={[
              "General public",
              "Patients or caregivers",
              "Diagnostic or treatment functions"
            ]} />
            <p>This app does not provide any direct medical advice or services to the public and is not suitable for general health monitoring or self-diagnosis.</p>
          </section>

          <Section title="5. Data Sharing and Disclosure" paragraph="We do not sell or rent your personal data. Your data may only be shared with:" items={[
            "Verified RIC staff for operational purposes",
            "Authorized third-party service providers under strict confidentiality and data security agreements"
          ]} />

          <section style={styles.section}>
            <h2 style={styles.heading}>6. Cookies and Tracking Technologies</h2>
            <p>Our website uses cookies for:</p>
            <List items={[
              "Remembering preferences",
              "Performance monitoring",
              "Content improvement"
            ]} />
            <p>Users can manage or disable cookies via browser settings, though certain features may be limited.</p>
          </section>

          <Section title="7. Data Security" paragraph="We apply industry-standard security protocols to:
Prevent unauthorized access or misuse of data, secure internal communication channels, and restrict access to only verified personnel via encrypted logins. All app data is encrypted during transmission and access is controlled using secure login systems." />

          <section style={styles.section}>
            <h2 style={styles.heading}>8. Your Rights</h2>
            <p>You may:</p>
            <List items={[
              "Request access to your data",
              "Request correction or deletion of submitted data",
              "Contact us with any concerns regarding your data privacy"
            ]} />
            <p>Contact Information:</p>
            <p>
              📧 Email: <a href="mailto:info@ricgop.online">info@ricgop.online</a><br />
              📞 Phone: (051) 9281111<br />
              🏢 Address: Rawal Rd, Chaklala Cantt., Rawalpindi, 46000
            </p>
          </section>

          <Section title="9. Data Safety (for Google Play)" paragraph="We have completed the Google Play Data safety section with accurate declarations regarding:
- Types of data collected
- Purposes of data use
- Data encryption
- User rights over data
- App access restrictions

Login credentials and demo access for Google Play reviewers are provided via the Play Console as required." />

          <Section title="10. Changes to This Privacy Policy" paragraph="We may update this policy to reflect changes in technology, laws, or operational practices. Updates will be posted on this page with a revised effective date." />

          <Section title="11. Developer and Organization Identity (Google Play Compliance)" paragraph={`Developer Account Type: Organization
Organization Name: Rawalpindi Institute of Cardiology (RIC)
Legal Entity Address: Rawal Rd, Chaklala Cantt., Rawalpindi, 46000
Developer Contact (Play Store): info@ricgop.online / (051) 9281111
D-U-N-S Number: 64-579-0259`} />

        </div>
      </div>

      <FooterThree />
    </main>
  );
};

const Section = ({ title, items, paragraph }) => (
  <section style={styles.section}>
    <h2 style={styles.heading}>{title}</h2>
    {paragraph && paragraph.split('\n').map((line, i) => <p key={i}>{line}</p>)}
    {items && <List items={items} />}
  </section>
);

const List = ({ items }) => (
  <ul style={styles.list}>
    {items.map((item, index) => (
      <li key={index} style={styles.listItem}>{item}</li>
    ))}
  </ul>
);

const styles = {
  wrapper: {
    backgroundColor: "#f2f6fc",
    padding: "40px 20px",
    minHeight: "100vh"
  },
  card: {
    maxWidth: "1500px",
    margin: "0 auto",
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "14px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    animation: "fadeIn 1s ease-in-out"
  },
  header: {
    textAlign: "center",
    paddingBottom: "30px",
    borderBottom: "2px solid #eee"
  },
  title: {
    fontSize: "2.5rem",
    color: "#0056b3",
    marginBottom: "0.3rem"
  },
  subtitle: {
    fontSize: "1rem",
    color: "#555"
  },
  section: {
    marginTop: "30px"
  },
  heading: {
    color: "#0056b3",
    marginBottom: "10px"
  },
  subheading: {
    color: "#0077cc",
    marginTop: "15px",
    marginBottom: "5px"
  },
  list: {
    paddingLeft: "20px",
    marginTop: "8px"
  },
  listItem: {
    marginBottom: "8px"
  }
};

export default PrivacyMain;
